import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page-classes" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "title-classes" }, null, -1)
const _hoisted_3 = { class: "classes-ul" }
const _hoisted_4 = { class: "classes-item" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]

import { NTabs, NTabPane } from "naive-ui";
import useClasses from "@/composables/useClasses";
import { useRouter } from "vue-router";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { classes } = useClasses();
let tabV = ref("冒险家");

function onTabUpdate() {
  console.log(111);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(NTabs), {
      "justify-content": "space-evenly",
      type: "line",
      "default-value": _unref(tabV),
      "on-update:value": onTabUpdate
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classes).data, (c, index) => {
          return (_openBlock(), _createBlock(_unref(NTabPane), {
            name: c.name,
            tab: c.name,
            key: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.transfer, (item, i) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    to: item.OutLink,
                    key: i,
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate }) => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                          class: "avatar",
                          onClick: navigate
                        }, [
                          _createElementVNode("img", {
                            src: `${item.HomeImagePath}`,
                            alt: ""
                          }, null, 8, _hoisted_6)
                        ], 8, _hoisted_5),
                        _createElementVNode("p", null, _toDisplayString(item.Title), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["name", "tab"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["default-value"])
  ]))
}
}

})